import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { useService } from '../../../../../services/services';
import { useEffect, useState } from 'react';
import Group from '../../../../../components/form/elements/group';
import * as yup from 'yup';
import Text from '../../../../../components/form/elements/text';
import {
  date,
  dealType,
  employee,
  makeButton,
  renderDealTable,
} from '../form-parts';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import TextArea from '../../../../../components/form/elements/text-area';
import { useWarehouseContext } from '../warehouse-context';
import Hidden from '../../../../../components/form/elements/hidden';
import css from './spent.module.css';

export function useSpentForm(mode, formMethods = null) {
  const { t } = useTranslation();
  const { farmId } = useParams<{ farmId: string }>();
  const { employeeService, dealService } = useService();
  const { setIsOpen, setFormValues } = useWarehouseContext();

  useEffect(() => {
    if (formMethods) {
      dealService.docmentCount(farmId).subscribe((dealCount) => {
        formMethods.setValue(
          'purchase_document_number',
          `${new Date().getFullYear()}/${dealCount + 1}`
        );
      });
    }
  }, [dealService, farmId, formMethods]);

  const handleClick = () => {
    setIsOpen(true);
    setFormValues(undefined);
  };

  const [form] = useState(() => [
    Group(
      [
        Group(
          [
            dealType(t, true),
            date(true),
            Text(
              'purchase_document_number',
              'pages.warehouse.deals.purchase_document_number',
              null,
              null,
              true
            ),
            employee(employeeService, farmId, true),
          ],
          null,
          false,
          false,
          true,
          css['form_body_top_group_top']
        ),
        Group(
          [
            Text(
              'purpose_and_place_of_use',
              'pages.warehouse.deals.purpose_and_place_of_use',
              null,
              null,
              true
            ),
          ],
          null,
          false,
          false,
          true,
          css['form_body_top_group_bottom']
        ),
      ],
      null,
      false,
      false,
      false,
      css['form_body_top']
    ),
    Group([
      mode === 'view'
        ? () => null
        : makeButton(
            'pages.warehouse.products.add-product',
            'pink-button',
            '',
            faPlus,
            false,
            handleClick
          ),
    ]),
    Hidden('products_exists'),
    Group(
      [renderDealTable(mode)],
      null,
      false,
      false,
      true,
      css['table-container']
    ),
    Group([
      TextArea('comment', 'pages.warehouse.deals.notes', 2, true, 'full-width'),
    ]),
  ]);

  return form;
}

export const spentSchema = (isRequired: boolean = false) => {
  return yup.object().shape({
    type: yup.object().shape({
      value: yup.string().required(),
    }),
    date: yup.date().required(),
    purpose_and_place_of_use: isRequired
      ? yup.string().required()
      : yup.string().nullable(),
    employee_id: yup.object().shape({
      value: isRequired ? yup.string().required() : yup.string().nullable(),
    }),
    products_exists: yup.bool().required(),
  });
};
